export default __webpack_public_path__ + "static/media/vsComputer.f7da76e7.jpg";